import React from 'react';
import { Grid, InputAdornment, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { RegularRate, doubleTimeFactor, doubleTimeRate } from 'app/models/Placement/PlacementMods';
import { DoubleTimeFactor } from '../../PayRate/PayFactor/DoubleTimeFactor';
import { getCalculatedAmount } from './BillOvertime';
import { validDecimal } from 'app/helpers/numberHelper';
import { getInvalidAmount } from './BillOrientation';

export const BillDoubleTime = ({ classes, isModEdit }: { classes: any; isModEdit: boolean }) => {
  const { t } = useTranslation();
  const { control, getValues, setValue } = useFormContext();
  const doubleTimeValue = useWatch<any>({ name: 'doubleTimeRate' });
  const regularRateValue = useWatch<string>({ name: RegularRate });

  return (
    <Grid item className={classes.flex}>
      <Controller
        name={doubleTimeRate}
        control={control}
        render={({ field: { onChange, value, ...rest } }) => (
          <TextField
            value={doubleTimeValue}
            className={classes.billFactorTextfields}
            InputLabelProps={{
              shrink: doubleTimeValue,
            }}
            onChange={e => {
              if (validDecimal(e.target.value, { numberLength: 6, decimalLength: 2 })) {
                setValue(doubleTimeRate, e.target.value);
                onChange(e.target.value);
                setValue(doubleTimeFactor, '');
              }
            }}
            variant="filled"
            label={`${t(`placement.placementMods.${doubleTimeRate}`)}`}
            helperText={regularRateValue ? getCalculatedAmount(getValues, doubleTimeRate) : getInvalidAmount()}
            InputProps={{
              readOnly: !isModEdit,
              style: {
                pointerEvents: isModEdit ? 'auto' : 'none',
              },
              startAdornment: (
                <>{doubleTimeValue && <InputAdornment position="start">{t('currency.dollar')}</InputAdornment>}</>
              ),
              sx: { fontSize: '14px' },
            }}
            {...rest}
          />
        )}
      />
      <div className={classes.middleText}>{'OR'}</div>
      <DoubleTimeFactor classes={classes} currentMod={'BillRate'} isModEdit={isModEdit} />
    </Grid>
  );
};
